<template>
  <div>
    <report-base
      title="Product Mix"
      table-class="analytics-tables--products"
      subject="products"
      :items="products"
      :fields="fields"
      :is-loading="loading"
      @reload="loadData"
    />
  </div>
</template>

<script>
import AnalyticsMixin from './mixin';

export default {
  name: 'analytics-products',

  mixins: [
    AnalyticsMixin
  ],

  data() {
    return {
      products: [],
      filter: '',
      fields: [
        {
          key: 'name',
          label: 'Item Name',
          sortable: true,
        },
        {
          key: 'category',
          label: 'Category',
          sortable: true,
        },
        {
          key: 'description',
          label: 'Description',
          sortable: true,
        },
        {
          key: 'count',
          label: 'Quantity',
          sortable: true,
        },
        {
          key: 'revenue',
          label: 'Revenue',
          sortable: true,
        }
      ]
    };
  },

  mounted() {
    this.loadData();
  },

  methods: {
    loadData () {
      this.loading = true;

      this.fetchData('products')
        .then(res => {
          this.products = res.data
            .map(product => {
              product.revenue = this.formatMoney(product.revenue);
              product.count = product.count
                ? product.count
                : '';

              return product;
            });
        })
        .catch(err => {
          this.errorNotification('Failed to fetch booking report!');
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss">
  .analytics-tables--products {
    table {
      min-width: 800px !important;
      position: relative;
    }
  }
</style>
